class FollowUpRule {
  public skipTo: string;

  public selectedOptionId?: string;

  public selectedValue?: string;

  constructor(skipTo: string, selectedOptionId: string, selectedValue: string) {
    this.skipTo = skipTo;
    this.selectedOptionId = selectedOptionId;
    this.selectedValue = selectedValue;
  }

  public static parse(object: any) {
    const { SkipTo, SelectedOptionId, SelectedValue } = object;
    return new FollowUpRule(SkipTo, SelectedOptionId ?? undefined, SelectedValue ?? undefined);
  }
}

export default FollowUpRule;
